import { render } from "./InstitutionalContent.vue?vue&type=template&id=23a2fa7a&scoped=true"
import script from "./InstitutionalContent.vue?vue&type=script&lang=js"
export * from "./InstitutionalContent.vue?vue&type=script&lang=js"

import "./InstitutionalContent.vue?vue&type=style&index=0&id=23a2fa7a&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a2fa7a"]])

export default __exports__